import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'name',
        label: i18n.t('commission.name'),
        policies: {
            commission: ['create']
        },
    },
    {
        key: 'display_name',
        label: i18n.t('commission.display_name'),
    },
    {
        key: 'store',
        label: i18n.t('store._'),
        policies: {
            commission: ['view_any_or_group']
        }
    },
    {
        key: 'conversionType',
        label: i18n.t('commission.conversion_type'),
    },
    {
        key: 'benefit',
        label: i18n.t('commission._'),
    },
    {
        key: 'actions',
        label: i18n.t('actions'),
        policies: {
            commission: ['create']
        },
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
]